<template>
  <div>
    <Alert class="mb-4">
      Lorsqu’une vente est effectuée via prélèvement SEPA (RIB), une période de validation bancaire est nécessaire avant
      que le paiement ne soit définitivement confirmé — un délai pouvant aller jusqu’à 5 jours ouvrés selon les banques.
      Le contrat n’apparaîtra dans votre espace qu’une fois ce paiement validé.
    </Alert>
    <LeadsList status="waiting_for_confirmation" :noDataMsg="$t('NoLeadProcessing')" />
  </div>
</template>

<script>
import { Alert } from "@estaly/ui";
import LeadsList from "@/components/leads/LeadsList.vue";

export default {
  components: {
    Alert,
    LeadsList,
  },
};
</script>
